import React, { Component } from "react";
import { connect } from "react-redux";
var $ = window.$ || {}

class WineScript extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
        userData: JSON.parse(localStorage.getItem('userData'))
    };

    window.cart = [];
  }

  getNext = () => {
      let i = 0;
      $("#carouselExampleControls").on('slid.bs.carousel', function(evt) {
          if (i == 0) {
              i++;
              window.wineNext();
          }
      });
  }

  getPrev = () => {
      let i = 0;
      $("#carouselExampleControls").on('slid.bs.carousel', function(evt) {
          if (i == 0) {
              i++;
              window.winePrevious();
          }
      });
  }
  
  render() {

    return (
    
      <div className="test-script h-100">
        <div className="overflow-hidden h-100">
          <div id="carouselExampleControls" data-interval="false" className="carousel slide carousel-fade script-info h-100" data-ride="carousel">
            <div className="carousel-inner h-100 position-relative">
              <div className="height-script h-100 position-relative">
              {/*<a href="javascript:void(0)" id="wineScript" data-toggle="modal" data-target="#show-details1" className="mr-5 show-full-script show-hide-script scrpt1 d-inline-block">*/}
              <a href="javascript:void(0)" id="wineScript" className="mr-5 show-full-script show-hide-script scrpt1 d-inline-block opacity-fade">
                <img src="./images/showscript.png" />
                <p className="text-center mb-0 text-white font-14">Script</p>
              </a>
                <span id="winscript-items">
                {
                  this.state.userData.sessionData.scriptDetail.map((opt, i) =>
                    <div className="carousel-item  h-100 d-flex justify-content-start flex-direction-column" key={i} id={i}>
                      <div className="bg-gray animtee position-relative top-rounded d-md-flex ht-20 justify-content-between align-items-center px-3 add-remove-round">
                        <h3 className="main-heading font-size-16"><span className="ml-md-4 font-size-16 "><span className="fitness-counter1">{i+1}</span>/{this.state.userData.sessionData.scriptDetail.length} {this.state.userData.sessionData.scriptType}</span></h3>
                        <a className="carousel-control-prev d-inline-block" href="#carouselExampleControls" role="button" data-slide="prev" onClick={this.getPrev.bind(this)} >
                            <img src="./images/prev-icon.png" className="next-btn" />
                            <p className="text-center mb-0 text-white font-14">Prev</p>
                        </a>
                       
                        <a className="carousel-control-next d-inline-block" href="#carouselExampleControls" role="button" data-slide="next" id="winscript"  onClick={this.getNext.bind(this)}>
                          <img src="./images/next-icon.png" className="next-btn" />
                          <p className="text-center mb-0 text-white font-14">Next</p>
                        </a>
                      </div>
                       
                        <div className="bg-gray bottom-rounded px-3 pb-3 pb-2 ht-80 item-description script-section d-block flex-grow-1">
                        <div className="max-h200 h-100 mt-2 scroller">
                          <h4 className="item-name">{opt.name}</h4>
                          <div className="row">
                         
                            <ul className="col-12 col-md-12 col-lg-12 pr-5 list-info">
                            {opt.attribute.map(function(attrb, index){
                             return <li key={index}><span>{attrb.attrLabel}</span><span>{attrb.attrValue}</span></li>   
                            })}
                            </ul>
                          </div>
                        </div> 
                      </div>
                    </div>
                )}
                </span>
               <div className="overlay1"></div>
            </div>            
            </div>
          </div>       
        </div>
      </div>
    );
  }
}

export default connect()(WineScript);